<script>
import { getImageUrl, isPresent } from "@/lib/utils"

export default {
  functional: true,

  props: {
    image: { type: Object, default: () => ({}) },
    altText: { type: String, default: "" }
  },

  render(h, { props, slots }) {
    return (
      <div class="avatar__content-wrapper d-flex">
        {isPresent(props.image) && (
          <img
            class="avatar"
            src={getImageUrl(props.image)}
            alt={props.altText}
          />
        )}
        {slots().default}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.avatar__content-wrapper {
  position: relative;
  top: -$size--3;
  padding: 0 $size--4;
  min-height: $size--5;
}

.avatar {
  border-radius: 50%;
  height: $size--10;
  width: $size--10;
  box-shadow: $box-shadow--medium;
  border: 3px solid $color-ui--white;
  background: $color-ui--white;
}
</style>
